import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import { Button, Select, Grid , MenuItem, Tooltip } from '@mui/material'
import { DataGrid } from "@mui/x-data-grid"
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditableInput from "./editableInput"
import EditableNumberInput from "./editableNumberInput"
import EditableReceivableInput from "./editableReceivableInput"
import EditableNumberReceivableInput from "./editableNumberReceivableInput"
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DATE_FORMAT_SHOW } from "src/utils/constants"

const FormComponent = ({
    operationsState, 
    setOperationsState,
    borderError,
    handleOperationChange, 
    handleUploadForm, 
    // closeModal,
    openAlert
}) => {

    // Memoriza borderError para evitar re-renderizações desnecessárias
    const borderErrorMemo = useMemo(() => ({...borderError}), [borderError])

    const handleAddOperation = () => {
        setOperationsState((prevState) => {
            if (prevState.length >=15){
                openAlert("O máximo de operações permitidas é 15")
                return prevState
            }
            const lastId = prevState.length > 0 ? prevState[prevState.length - 1].id : 0
            const nextId = lastId + 1
            return [
                ...prevState,
                {
                    id: nextId,
                    idOperacao: '',
                    dataOriginacao: dayjs().format(DATE_FORMAT_SHOW),
                    CNPJ_CPF: '',
                    indexador: 'PRE',
                    volumeFinanceiro: '1.000,00',
                    prazoOperacao: '252',
                    PDDObservada: '',
                    recebivel: 'FINANCIAMENTO PJ',
                    garantia: 'SEM GARANTIA',
                    valorGarantia: '',
                    PDInterno: '',
                    LGDInterno: '',
                    EADInterno: '',
                    ScoreInterno: ''
                }
            ]
        })
    }

    const handleRemoveOperation = (id) => {
        console.log(id)

        if (operationsState.length < 2) return
        const list = operationsState.filter(item => item.id !== id)
        setOperationsState(list)
    }

    const indexadorOptions = [
        "TR", "TLP", "TJLP", "SELIC_Taxa", "SELIC_Percentual", "PRE", "IPC_FIPE", "IPCA", "INPC", "INCC_DI", "IGPM", "IGPDI", "DOLAR", "CDI_Taxa", "CDI_Percentual"
    ]

    const recebivelOptions = [
        "CONFISSAO DE DIVIDA PF", "CAPITAL DE GIRO PJ", "CARTAO DE CREDITO PARCELADO PF", "CARTAO DE CREDITO PARCELADO PJ", "CONSIGNADO INSS PF", "CONSIGNADO PRIVADO PF",
        "OUTROS RECEBIVEIS PJ", "CARTAO DE CREDITO ROTATIVO PF", "CARTAO DE CREDITO ROTATIVO PJ", "OUTROS RECEBIVEIS PF", "RECEBIVEIS DE CARTAO (FUMACA)",
        "FINANCIAMENTO ESTUDANTIL PF", "FINANCIAMENTO VEICULO PF", "CDC PF", "EMPRESTIMO COM GARANTIA PF", "CONSIGNADO PUBLICO PF", "FINANCIAMENTO IMOBILIARIO PF",
        "FINANCIAMENTO PJ", "DUPLICATA DE SERVICOS", "ANTECIPACAO DE RECEBIVEIS DE CARTAO", "DUPLICATA MERCANTIL", "FINANCIAMENTO AGRICOLA PF", "FINANCIAMENTO AGRICOLA PJ"

    ]

    const garantiaOptions = [
            "SEM GARANTIA", "OUTRAS GARANTIAS", "AF DE IMOVEIS", "AF DE OUTROS BENS IMOBILIARIOS", "AF DE BENS MOBILIARIOS", "HIPOTECA DE IMOVEIS",
            "PENHOR AGRICOLA", "AVAL", "FIANCA", "CARTA FIANCA", "CASH COLLATERAL", "TITULOS E VALORES MOBILIARIOS", "CESSAO FIDUCIARIA DE RECEBIVEIS PERFORMADOS",
            "CESSAO FIDUCIARIA DE RECEBIVEIS A PERFORMAR"
    ]

    const cleanFormattedNumber = (value) => {
        if (!value) return "0.00"
        return String(value).replace(/\./g, '').replace(',', '.')
    }
    
    return (
        <form onSubmit={(e) => {
            e.preventDefault()
            handleUploadForm()
        }}>
            <Grid container direction={'column'} rowSpacing={2}>
                <Grid item width={'100%'}>
                    <DataGrid
                        getRowId = {(row) => row.id} // Define a chave única da linha
                        autoHeight={false}
                        autoPageSize={false}
                        showColumnVerticalBorder
                        showCellVerticalBorder
                        hideFooter
                        rows={operationsState}
                        columns={[
                            {
                                field: 'id',
                                headerName: '#',
                                align: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                headerAlign: "center",
                            },
                            {
                                field: 'idOperacao',
                                headerName: 'IDOperacao',
                                description: 'Insira o nome da operação caso queira',
                                align: "center",
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    console.log("Valor de idOperacao:", value)
                                    console.log("idOperacao: ", value, "| Tipo: ", typeof value)
                                
                                    return (
                                        <EditableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('idOperacao', id, cellValue)}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'dataOriginacao',
                                headerName: 'DataOriginacao',
                                description: 'Preencha a data de originação de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    // const index = id ? id - 1 : 0
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index dataOriginacao:", index)
                                    console.log("dataOriginacao: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError dataOriginacao:", borderError.dataOriginacao)       
                                                              
                                    const dataOriginacaoError = borderErrorMemo[index]?.dataOriginacao ?? false
                                    console.log("Valor de dataOriginacaoError:", dataOriginacaoError)

                                    return (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                value={value ? dayjs(value, "DD/MM/YYYY") : null}
                                                onChange={(newValue) => {
                                                    const formattedDate = newValue ? dayjs(newValue).format('DD/MM/YYYY') : ""
                                                    handleOperationChange('dataOriginacao', id, formattedDate)
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        error: dataOriginacaoError,
                                                        helperText: dataOriginacaoError ? 'Data inválida' : '',
                                                        variant: "outlined",
                                                        fullWidth: true
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )
                                },
                            },
                            {
                                field: 'CNPJ_CPF',
                                headerName: 'CNPJ_CPF',
                                description: 'Preencha o CNPJ ou CPF de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index CNPJ_CPF:", index)
                                    console.log("CNPJ_CPF: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError CNPJ_CPF:", borderError.CNPJ_CPF)
                                    
                                    const CNPJ_CPFError = borderErrorMemo[index]?.CNPJ_CPF ?? false
                                    console.log("Valor de CNPJ_CPFError:", CNPJ_CPFError)

                                    return (
                                        <EditableReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('CNPJ_CPF', id, cellValue)}
                                            error={CNPJ_CPFError} 
                                        />
                                    )
                                },
                            },
                            {
                                field: 'indexador',
                                headerName: 'Indexador',
                                description: 'Escolha entre as opções disponíveis o indexador para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index indexador:", index)
                                    console.log("indexador: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError indexador:", borderError.indexador)

                                    const indexadorError = borderErrorMemo[index]?.indexador ?? false
                                    console.log("Valor de indexadorError:", indexadorError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange('indexador', id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: indexadorError ? "red" : "transparent"
                                            }}
                                        >
                                            {indexadorOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'volumeFinanceiro',
                                headerName: 'VolumeFinanceiro',
                                description: 'Informe o volume financeiro para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index volumeFinanceiro:", index)
                                    console.log("VolumeFinanceiro: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError volumeFinanceiro:", borderError.volumeFinanceiro)

                                    const volumeFinanceiroError = borderErrorMemo[index]?.volumeFinanceiro ?? false
                                    console.log("Valor de volumeFinanceiroError:", volumeFinanceiroError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('volumeFinanceiro', id, cleanFormattedNumber(cellValue))}
                                            error={volumeFinanceiroError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'prazoOperacao',
                                headerName: 'PrazoOperacao',
                                description: 'Informe o prazo da operação para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {        
                                    const index = operationsState.findIndex((op) => op.id === id)     
                                    console.log("Valor do index prazoOperacao:", index)
                                    console.log("prazoOperacao: ", value, "| Tipo: ", typeof value)
                                    // console.log("Valor de borderError prazoOperacao:", borderError)

                                    const prazoOperacaoError = borderErrorMemo[index]?.prazoOperacao ?? false
                                    console.log("Valor de prazoOperacaoError:", prazoOperacaoError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('prazoOperacao', id, cleanFormattedNumber(cellValue))}
                                            error={prazoOperacaoError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'PDDObservada',
                                headerName: 'PDDObservada',
                                description: 'Informe a PDD observada para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)     
                                    console.log("Valor do index PDDObservada:", index)
                                    console.log("PDDObservada: ", value, "| Tipo: ", typeof value)
                                    // console.log("Valor de borderError PDDObservada:", borderError)
                                    
                                    // const PDDObservadaError = borderErrorMemo[index]?.PDDObservada ?? false
                                    // console.log("Valor de PDDObservadaError:", PDDObservadaError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('PDDObservada', id, cleanFormattedNumber(cellValue))}
                                            // error={PDDObservadaError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'valorGarantia',
                                headerName: 'ValorGarantia',
                                description: 'Informar o valor da garantia de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index PDDObservada:", index)
                                    console.log("valorGarantia: ", value, "| Tipo: ", typeof value)

                                    return (
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('valorGarantia', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'recebivel',
                                headerName: 'Recebivel',
                                description: 'Escolha entre as opções disponíveis o recebivel para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    // const index = id ? id - 1 : 0
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index recebivel:", index)
                                    console.log("recebivel: ", value, "| Tipo: ", typeof value)
                                    // console.log("Valor de borderError recebivel:", borderError)   

                                    const recebivelError = borderErrorMemo[index]?.recebivel ?? false
                                    console.log("Valor de recebivelError:", recebivelError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange('recebivel', id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: recebivelError ? "red" : "transparent"
                                            }}
                                        >
                                            {recebivelOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'garantia',
                                headerName: 'Garantia',
                                description: 'Escolha entre as opções disponíveis a garantia para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index garantia:", index)
                                    console.log("garantia: ", value, "| Tipo: ", typeof value)

                                    const garantiaError = borderErrorMemo[index]?.garantia ?? false
                                    console.log("Valor de garantiaError:", garantiaError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange("garantia", id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: garantiaError ? "red" : "transparent"
                                            }}
                                        >
                                            {garantiaOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'PDInterno',
                                headerName: 'PDInterno',
                                description: 'Informar o PDInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index PDInterno:", index)
                                    console.log("PDInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('PDInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'LGDInterno',
                                headerName: 'LGDInterno',
                                description: 'Informar o LGDInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index LGDInterno:", index)
                                    console.log("LGDInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('LGDInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'EADInterno',
                                headerName: 'EADInterno',
                                description: 'Informar o EADInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index EADInterno:", index)
                                    console.log("EADInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('EADInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'ScoreInterno',
                                headerName: 'ScoreInterno',
                                description: 'Informar o ScoreInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index ScoreInterno:", index)
                                    console.log("ScoreInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('ScoreInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'actions',
                                headerName: 'Excluir',
                                align: "center", headerAlign: "center",
                                width: 120,
                                renderCell: (params) => (
                                    <Button onClick={() => handleRemoveOperation(params.row.id)} color="error" align="center">
                                        <DeleteOutlineOutlinedIcon />
                                    </Button>
                                ),
                            }
                        ]}
                        disableRowSelectionOnClick
                    />
                </Grid>
                <br />
                <Grid container justifyContent={"space-between"}>

                    <Grid item>
                        <Grid container spacing={1} justifyContent={"flex-start"}>
                            <Grid item>
                                <Tooltip title="Adicione as operações da sua concessão, até no máximo 15 linhas">
                                    <Button onClick={handleAddOperation} variant="contained">
                                        + Operação
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

export default FormComponent

FormComponent.propTypes = {
    operationsState: PropTypes.array.isRequired,
    setOperationsState: PropTypes.func.isRequired,
    borderError:PropTypes.object.isRequired,
    handleOperationChange: PropTypes.func.isRequired,
    handleUploadForm: PropTypes.func.isRequired,
    // closeModal: PropTypes.func.isRequired,
    openAlert: PropTypes.func.isRequired
}